import React, { Component } from 'react'
import Gallery from 'react-photo-gallery'
import Lightbox from 'react-images'
import ReactResizeDetector from 'react-resize-detector'
// eslint-disable-next-line
import windowSize from 'react-window-size'

class GallerySection extends Component{
    state = {
        columns: 3,
        currentImage: 0,
        lightboxIsOpen: false
    }

    openLightbox = (event, obj) => {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        })
    }
    closeLightbox = () => {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        })
    }
    gotoPrevious = () => {
        this.setState({
            currentImage: this.state.currentImage - 1,
        })
    }
    gotoNext = () => {
        this.setState({
            currentImage: this.state.currentImage + 1,
        })
    }

    _onResize = () => {
        const width = this.props.windowWidth
        let cols = this.state.columns

        cols = (width < 1200) ? (width < 992) ? (width < 768) ? (width < 576) ? 1 : 2 : 3 : 4 : 5

        this.setState({ columns: cols })
    }

    render() {
        const { css, title, content } = this.props

        return (
            <div className="container">
                <div className="row">
                    <div className={`col-lg-12 ${css} pb-4`} ></div>
                    <div className="text-center" style={{ margin: 'auto' }}>
                        {title && <h2 className="text-center lined">{title}</h2>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <Gallery photos={content.photos} columns={this.state.columns} onClick={this.openLightbox} />
                        <ReactResizeDetector handleWidth handleHeight onResize={this._onResize} />
                        <Lightbox
                            theme={{ container: { background: 'rgba(0, 0, 0, 0.85)' } }}
                            images={content.photos.map(x => ({ ...x, srcset: x.srcSet, caption: x.title }))}
                            backdropClosesModal={true}
                            onClose={this.closeLightbox}
                            onClickPrev={this.gotoPrevious}
                            onClickNext={this.gotoNext}
                            currentImage={this.state.currentImage}
                            isOpen={this.state.lightboxIsOpen}
                            width={1600}
                            imageCountSeparator=" / "
                            closeButtonTitle="Zavřít (Esc)"
                            leftArrowTitle="Předchozí (Levá šipka)"
                            rightArrowTitle="Další (Pravá šipka)"
                            showImageCount={false}
                            showCloseButton={false}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export { GallerySection }


// WEBPACK FOOTER //
// ./src/components/sections/Gallery.js